module.exports = __webpack_public_path__ + "img/weixin-weijiaohuan@3x.999f1f2c.svg";